import { render, staticRenderFns } from "./advantageView.vue?vue&type=template&id=3ec70cdb&scoped=true"
import script from "./advantageView.vue?vue&type=script&lang=js"
export * from "./advantageView.vue?vue&type=script&lang=js"
import style0 from "./advantageView.vue?vue&type=style&index=0&id=3ec70cdb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec70cdb",
  null
  
)

export default component.exports